<template>
  <article
    v-if="(this.component.name == 'NFeRecebidas') || (this.component.name == 'CTE' && this.component.tipo === 'tomados') ||
                  (this.component.name == 'NFSE' && this.component.tipo !== 'emitida')"
    class="d-inline-block"
  >
    <v-flex xs6 sm2 md2>
      <v-btn
        style="min-width: 109px;"
        slot="activator"
        @click.native="dialog = !dialog"
        class="bg_white"
      >
        <v-icon small color="teal" style="margin-right: 6px;">cloud_upload</v-icon>
        <small v-if="this.component.name === 'CTE'" style="color:black;">Upload CT-e</small>
        <small v-if="this.component.name === 'NFeRecebidas'" style="color:black;">Upload NF-e</small>
        <small v-if="this.component.name === 'NFSE'" style="color:black;">Upload NFS-e</small>
      </v-btn>
    </v-flex>

    <v-dialog
      @keydown.esc="dialog = false,table.resetAlert()"
      @keydown.enter="this.component.name == 'NFeRecebidas' || this.component.name === 'CTE' ? envXml() : enviarPDF()"
      v-model="dialog"
      persistent
      max-width="700px"
      v-if="dialog && (this.component.name == 'NFeRecebidas') || (this.component.name == 'CTE') ||
                  (this.component.name == 'NFSE' && this.component.tipo !== 'emitida')"
    >
      <v-card>
        <v-card-title>
          <span>
            <strong v-if="this.component.name === 'NFeRecebidas'">Enviar Nota Fiscal Eletrônica (NF-e)</strong>
            <strong v-if="this.component.name === 'CTE'">Enviar Conhecimento de Transporte (CT-e)</strong>
            <strong
              v-if="this.component.name === 'NFSE'"
            >Enviar Nota Fiscal Eletrônica de Serviço (NFS-e)</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialog = false">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-progress-linear
          color="teal"
          style="margin: 0;"
          v-if="this.sendingXML"
          :value="this.progressEnviando"
        ></v-progress-linear>
        <div v-if="this.sendingXML" style="text-align: center">
          <span
            style="background: -webkit-linear-gradient(bottom, teal, #8dffbf);-webkit-background-clip: text;font-weight: 800;-webkit-text-fill-color: transparent;margin-top: 6px;"
          >{{progressEnviando ? parseFloat(progressEnviando).toFixed(0) : progressEnviando }} %</span>
          <span class="animeDodgeLoading">.</span>
        </div>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <transition v-if="this.file != undefined && this.file.length > 0" name="fade">
                  <article>
                    <h4 style="display: inline-block;">Arquivos prontos para envio:</h4>
                    <h4
                      style="display: inline-block;position: absolute;right: 65px;color: grey;"
                    >Total: {{this.file.length}}</h4>
                    <div style="position: relative;">
                      <article v-if="errorSending">
                        <span
                          class="red--text"
                          style="font-size: 11px"
                        >Arquivos sem sucesso no envio</span>
                        <v-icon
                          style="font-size: 14px;"
                          class="custom_anime"
                          color="black"
                        >arrow_downward</v-icon>
                      </article>
                      <v-btn
                        flat
                        small
                        style="height: 20px!important;"
                        :style="errorSending ? 'position: absolute; right: 0; margin-top: -20px;' : ''"
                        color="cyan darken-3"
                        @click.native="resetFiles()"
                      >Limpar lista</v-btn>
                      <v-divider></v-divider>
                    </div>

                    <ol style="padding: 0px;max-height: 149px;overflow-y: scroll;">
                      <li
                        class="d-inline-block xml_envio"
                        style="white-space: nowrap;width: 40%;margin-right: 52px;"
                        v-for="(item,i) in file"
                        :key="i"
                      >
                        <div
                          class="xml_envio_div"
                          :class="degradeColor"
                          :title="item.name"
                          style="display: inline-block;min-width: 50%;width: 100%;overflow: hidden;text-overflow: ellipsis;margin-right: -10px;border-radius: 6px;padding: 3px 0;"
                        >{{item.name}}</div>
                        <v-tooltip bottom>
                          <v-btn
                            slot="activator"
                            color="red darken-4"
                            icon
                            flat
                            style="margin-top: -13px;margin-left: -2px;"
                            text-color="white"
                            dark
                            @click="removeColumn(item,i)"
                          >
                            <v-icon
                              class="material-icons"
                              style="font-size: 20px;"
                              dark
                              color="red darken-4"
                            >delete_forever</v-icon>
                          </v-btn>
                          <span>Remover este arquivo</span>
                        </v-tooltip>
                      </li>
                    </ol>
                  </article>
                </transition>
                <article v-if="fileEnviado.length > 0">
                  <span class="green--text" style="font-size: 11px">Arquivos enviados com successo</span>
                  <v-icon style="font-size: 14px;" class="custom_anime" color="black">arrow_downward</v-icon>
                  <h4
                    data-v-06e50aa7
                    style="display: inline-block; position: absolute; right: 65px; color: grey;"
                  >Total: {{this.fileEnviado.length}}</h4>
                  <ol style="padding: 0px;max-height: 149px;overflow-y: scroll; margin-top: 10px;">
                    <li
                      class="d-inline-block xml_envio"
                      style="white-space: nowrap;width: 40%;margin-right: 52px;"
                      v-for="(item,i) in fileEnviado"
                      :key="i"
                    >
                      <div
                        class="xml_envio_div successDegrade"
                        :title="item.name"
                        style="display: inline-block;min-width: 50%;width: 100%;overflow: hidden;text-overflow: ellipsis;margin-right: -10px;border-radius: 6px;padding: 3px 0;"
                      >{{item.name}}</div>
                    </li>
                  </ol>
                </article>
              </v-flex>

              <v-divider></v-divider>
              <v-flex xs12 sm12 md12>
                <inputFile
                  :text="'Selecionar arquivo'"
                  :prevIcon="'description'"
                  :component="this.component.name == 'NFeRecebidas' || this.component.name === 'CTE' ? 'xml' : 'pdf'"
                  @emitResetInput="emitResetInput($emit)"
                  @getFile="getFile($event)"
                ></inputFile>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions v-if="this.component.name === 'NFeRecebidas' || this.component.name === 'CTE'">
          <v-btn color="primary" flat @click.stop="dialog=false, table.resetAlert()">Fechar</v-btn>
          <v-btn color="success" @click.stop="envXml()">Enviar</v-btn>
        </v-card-actions>
        <v-card-actions v-if="this.component.name == 'NFSE'">
          <v-btn color="primary" flat @click.stop="dialog=false, table.resetAlert()">Fechar</v-btn>
          <v-btn color="success" @click.stop="enviarPDF()">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </article>
</template>
<script>
import NfeService from "@/domain/notas/nfe/NfeService";
import CteService from "@/domain/notas/cte/CteService"
import NfseService from "@/domain/notas/nfse/NfseService";
import inputFile from "@/components/shared/inputFile/InputFile.vue";
export default {
  props: ["component", "empresa", "table"],
  components: {
    inputFile: inputFile
  },
  data: () => ({
    dialog: false,
    file: [],
    fileEnviado: [],
    sendingXML: false,
    errorSending: false,
    degradeColor: "greyDegrade",
    progressEnviando: 0,
    selectedMun: 0
  }),
  watch: {
    dialog: function(newV, oldV) {
      this.resetFiles();
      this.sendingXML = false;
      this.progressEnviando = 0;
      this.fileEnviado = [];
    }
  },
  methods: {
    changeMunSelected(codmun) {
      this.selectedMun = codmun;
    },
    getFile(file) {
      if (file != undefined) {
        if (this.file.length > 0) {
          this.errorSending = false;
          this.degradeColor = "greyDegrade";
          for (let i = 0; i < file.length; i++) {
            if (
              !this.file.find(function(item, index, array) {
                let hasItem = false;
                array.forEach(elem => {
                  if (elem.name == file[i].name && elem.size == file[i].size) {
                    hasItem = true;
                    return;
                  }
                });
                return hasItem;
              })
            ) {
              this.file.push(file[i]);
            }
          }
        } else {
          this.file = file.slice();
        }
      }
    },
    emitResetInput(evento) {},
    resetFiles: function() {
      this.errorSending = false;
      this.degradeColor = "greyDegrade";
      this.file = [];
    },
    removeColumn(item, i) {
      this.file.splice(i, 1);
      console.log(this.file);
    },
    envXml: async function() {
      this.progressEnviando = 0;
      this.table.resetAlert();
      if (this.file != undefined && this.file.length > 0) {
        if (this.component.name == 'CTE'){
          this.service = new CteService(this.$http);
        }else{

          this.service = new NfeService(this.$http);
        }
        let length = this.file.length;
        let msgFailed = "Erro ao enviar seguintes xml: \n\n";
        let msgSuccess = "";
        let contOk = 0;
        let posEnviados = [];
        let arrayError = [];
        this.sendingXML = true;
        for (let i = 0; i < this.file.length; i++) {
          await this.service
            .sendXml(this.empresa._id, this.file[i])
            .then(resp => {
              this.progressEnviando = (i * 100) / this.file.length;
              if (!resp.ok) {
                arrayError.push(this.file[i]);
                msgFailed += `"${this.file[i].name}": ${resp.body.message}.\n\n`;
              } else {
                // console.log(`ITEM ENVIADO: ${this.file[i].name} ------- ${i}`)
                msgSuccess += `"${this.file[i].name}": enviado com sucesso. \n\n`;
                contOk++;
                posEnviados.push(i);
              }
            });
        }
        if (posEnviados.length > 0) {
          for (let i = 0; i < posEnviados.length; i++) {
            // console.log(`COLOCANDO ITEM NA LISTA: ${this.file[posEnviados[i]].name}  ------- ${i}`)
            this.fileEnviado.push(this.file[posEnviados[i]]);
          }
        }
        this.file = arrayError.slice();
        this.sendingXML = false;
        if (contOk == length) {
          //debugger;
          this.table.snackSuccess();
          this.table.snack.text =
            contOk == 1
              ? "Arquivo enviado com sucesso!"
              : "Arquivos enviados com sucesso!";
          this.table.snack.show = true;
          this.dialog = false;
        } else {
          this.degradeColor = "dangerDegrade";
          this.errorSending = true;
          let timeOut = 0;
          //debugger;
          if (contOk > 0) {
            contOk > 1
              ? (this.table.snack.multiple = true)
              : (this.table.snack.multiple = false);
            this.table.snack.text = msgSuccess;
            this.table.snackSuccess();
            this.table.snack.show = true;
            this.table.snack.time = 7000;
            timeOut = 8000;
          }

          if (arrayError.length > 0) {
            let auxAlert = this.table;
            setTimeout(function() {
              auxAlert.snack.multiple = true;
              auxAlert.snack.text = msgFailed;
              auxAlert.snackDanger();
              auxAlert.snack.time = length * 3000;
              auxAlert.snack.show = true;
            }, timeOut);
          }
        }

        let auxThis = this;
        this.table.loading = true;
        setTimeout(function() {
          auxThis.table.sendAtt = true;
        }, 3000);
        // this.table.sendAtt = true;
      } else {
        this.table.snack.text = "Necessário selecionar um arquivo!";
        this.table.snackAlert();
        this.table.snack.show = true;
      }
      this.table.resetAlert();
    },
    enviarPDF: async function() {
      //debugger;
      this.progressEnviando = 0;
      this.table.resetAlert();
      if (this.file != undefined && this.file.length > 0) {
        this.service = new NfseService(this.$http);
        let length = this.file.length;
        let msgFailed = "Erro ao enviar seguintes pdfs: \n\n";
        let msgSuccess = "";
        let contOk = 0;
        let posEnviados = [];
        let arrayError = [];
        this.sendingXML = true;
        for (let i = 0; i < this.file.length; i++) {
          await this.service
            .sendPdfRobo(this.empresa._id, this.file[i], this.file[i].name,this.selectedMun)
            .then(resp => {
              this.progressEnviando = (i * 100) / this.file.length;
              if (!resp && resp.status !== 200) {
                arrayError.push(this.file[i]);
                msgFailed += `"${this.file[i].name}": ${resp.body.error}.\n\n`;
              } else {
                // console.log(`ITEM ENVIADO: ${this.file[i].name} ------- ${i}`)
                msgSuccess += `"${this.file[i].name}": enviado com sucesso. \n\n`;
                contOk++;
                posEnviados.push(i);
              }
            });
        }
        if (posEnviados.length > 0) {
          for (let i = 0; i < posEnviados.length; i++) {
            // console.log(`COLOCANDO ITEM NA LISTA: ${this.file[posEnviados[i]].name}  ------- ${i}`)
            this.fileEnviado.push(this.file[posEnviados[i]]);
          }
        }
        this.file = arrayError.slice();
        this.sendingXML = false;
        if (contOk == length) {
          //debugger;
          this.table.snackSuccess();
          this.table.snack.text =
            contOk == 1
              ? "Arquivo enviado com sucesso!"
              : "Arquivos enviados com sucesso!";
          this.table.snack.show = true;
          this.dialog = false;
        } else {
          this.degradeColor = "dangerDegrade";
          this.errorSending = true;
          let timeOut = 0;
          //debugger;
          if (contOk > 0) {
            contOk > 1
              ? (this.table.snack.multiple = true)
              : (this.table.snack.multiple = false);
            this.table.snack.text = msgSuccess;
            this.table.snackSuccess();
            this.table.snack.show = true;
            this.table.snack.time = 7000;
            timeOut = 8000;
          }

          if (arrayError.length > 0) {
            let auxAlert = this.table;
            setTimeout(function() {
              auxAlert.snack.multiple = true;
              auxAlert.snack.text = msgFailed;
              auxAlert.snackDanger();
              auxAlert.snack.time = length * 3000;
              auxAlert.snack.show = true;
            }, timeOut);
          }
        }

        let auxThis = this;
        this.table.loading = true;
        setTimeout(function() {
          auxThis.table.sendAtt = true;
        }, 3000);
        // this.table.sendAtt = true;
      } else {
        this.table.snack.text = "Necessário selecionar um arquivo!";
        this.table.snackAlert();
        this.table.snack.show = true;
      }
      this.table.resetAlert();
    }
  }
};
</script>
<style>
.active {
  background-color: rgb(0, 150, 136) !important;
}
ol::-webkit-scrollbar {
  width: 7px;
  height: 14px;
}
div.greyDegrade {
  background: linear-gradient(to right, #ff000000, #ececec);
}
div.successDegrade {
  background: linear-gradient(to right, #f0d2d200, #a4d9a6);
}
div.dangerDegrade {
  background: linear-gradient(to right, #ff000000, #f8e6e6);
}
.fade-leave {
  opacity: 1;
}
.fade-leave-active {
  transition: all 1s;
  opacity: 0;
}
.custom_anime {
  animation: logo 1s infinite alternate;
}
.custom_anime path {
  stroke: black;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 1.5s ease-in alternate infinite;
}

.lista-colunas {
  width: 46%;
  margin: 0 2% 0 0;
}
.lista-colunas ul {
  height: 40vh;
  list-style-type: none;
  overflow: auto;
}
#colItensAtivas i {
  transform: rotateY(180deg);
}
#title {
  font-size: 10px;
  cursor: default;
  text-align: center;
  text-transform: uppercase;
  font-weight: 800;
  padding: 6px;
  font-family: "Quicksand", sans-serif;
  color: #25476a;
}

@keyframes dash {
  from {
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}
@-moz-keyframes logo {
  from {
    transform: translate(0%, -2%);
  }
  to {
    transform: translate(0%, -23%);
  }
}
@-webkit-keyframes logo {
  from {
    transform: translate(0%, -2%);
  }
  to {
    transform: translate(0%, -23%);
  }
}
@-o-keyframes logo {
  from {
    transform: translate(0%, -2%);
  }
  to {
    transform: translate(0%, -23%);
  }
}
@keyframes logo {
  from {
    transform: translate(0%, -2%);
  }
  to {
    transform: translate(0%, -23%);
  }
}

.animeDodgeLoading {
  animation: dodge 1s infinite alternate;
  position: absolute;
  margin-left: -24px;
  margin-top: -2px;
  font-weight: 800;
  font-size: 21px;
  background: -webkit-linear-gradient(bottom, teal, #8dffbf);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
@-moz-keyframes dodge {
  from {
    transform: translate(150%, 0%);
  }
  to {
    transform: translate(-100%, 0%);
  }
}
@-webkit-keyframes dodge {
  from {
    transform: translate(150%, 0%);
  }
  to {
    transform: translate(-100%, 0%);
  }
}
@-o-keyframes dodge {
  from {
    transform: translate(150%, 0%);
  }
  to {
    transform: translate(-100%, 0%);
  }
}
@keyframes dodge {
  from {
    transform: translate(150%, 0%);
  }
  to {
    transform: translate(-100%, 0%);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnUpload/BtnUpload.vue